import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Button,
    Text,
    ModalFooter,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

const SubscriptionEditNotAllowedModal = ({isOpen, onClose, title, message}) => (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
        <ModalOverlay />
        <ModalContent>
            <ModalHeader>{title}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <Text mb={8}>{message}</Text>
            </ModalBody>
            <ModalFooter>
                <Button width="100%" variant="primary" onClick={onClose}>
                    <FormattedMessage
                        id="subscription_edit_not_allowed.close"
                        defaultMessage="Close"
                    />
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
)

SubscriptionEditNotAllowedModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
}

export default SubscriptionEditNotAllowedModal
